import { EditPronounsService } from './services/edit_pronouns_service';
import { SettingsFeatureListComponent } from './components/settings_feature_list/settings_feature_list_component';
import { SettingsFeatureListController } from './components/settings_feature_list/settings_feature_list_controller';
import { SettingsWelcomeComponent } from './components/settings_welcome/settings_welcome_component';
import { SettingsWelcomeController } from './components/settings_welcome/settings_welcome_controller';
import { SettingsLogoutConfigurationService } from './services/settings_logout_configuration_service';
import { SettingsStateConfigurationService } from './services/settings_state_configuration_service';
import { SettingsCapabilityConfiguration } from './settings_configuration';
import { EditPronounsModalComponent, EditPronounsModalController } from './modals/edit_pronouns';
require('./about/about_module');

angular
  .module('capability-ng-settings', ['about'])
  .component('settingsWelcome', new SettingsWelcomeComponent())
  .component('settingsFeatureList', new SettingsFeatureListComponent())
  .component('editPronounsModal', new EditPronounsModalComponent())
  .service('ngSettingsStateConfigurationService', SettingsStateConfigurationService)
  .service('ngSettingsLogoutConfigurationService', SettingsLogoutConfigurationService)
  .service('ngEditPronounsService', EditPronounsService)
  .controller('ngSettingsWelcomeController', SettingsWelcomeController)
  .controller('ngSettingsFeatureListController', SettingsFeatureListController)
  .controller('ngEditPronounsModalController', EditPronounsModalController)
  .service('ngSettingsCapabilityConfiguration', SettingsCapabilityConfiguration);

import './core';

export const NO_PRONOUNS_STRING = 'None - do not show';

export * from './services/settings_logout_configuration_service';
export * from './services/settings_state_configuration_service';
export * from './settings_configuration';

export default 'capability-ng-settings';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/main.ts